module.exports = __webpack_public_path__ + "img/c00_buildingtechcompositebow_Normal_ua.af36a74a.webp";